import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';
import { convertToTitleCase } from '@/services/utils/global.js';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, dentalScheduleData) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(dentalScheduleData),

            styles: {
                header: {
                    fontSize: 20,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 9,
                font: 'SulaimanLipi'
            },

            info: {
                title: "Dental Schedule"
            }
        }

        pushIntoTable(doc, dentalScheduleData)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = () => {
        return [
            {
                text: "Dental Schedule",
                style: 'header',
                alignment: 'center',
                fontSize: 12,
                decoration: 'underline',
                margin: [0, 0, 0, 10],
                bold: true,
            },
            {

                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: ['15%', '8%', '12%', '14%', '14%', '12%', '15%', '10%'],
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0 || rowIndex === 1) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            }
        ];
    };

    const pushIntoTable = (doc, dentalScheduleData) => {
        const tableHeader = getTableHeader();
        doc.content[1].table.body.push(tableHeader);

        dentalScheduleData.forEach((item) => {
            const rowData = getRowData(item);
            return doc.content[1].table.body.push(rowData);
        });
    }

    const getTableHeader = () => {
        return [
            { text: 'Patient(Id)', bold: true },
            { text: 'Gender', bold: true },
            { text: 'Mobile No', bold: true },
            { text: 'Age', bold: true },
            { text: 'Schedule Date', bold: true },
            { text: 'Doctor', bold: true },
            { text: 'Service Name', bold: true },
            { text: 'Status', bold: true },
        ]
    }

    const getRowData = (item) => {
            return [
                { text: item.patient_name + '(' + item.patient_serial_no + ')' },
                { text: convertToTitleCase(item.patient_gender) },
                { text: item.patient_mobile_no },
                { text: item.patient_age },
                { text: item.start_time },
                { text: item.doctor_name },
                { text: item.product_name },
                { text: convertToTitleCase(item.status) },
            ]
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;